import api from './api';

export const leaderboardService = {
  // Teacher: Get class leaderboard
  async getClassLeaderboard(limit = 10) {
    const response = await api.get('/leaderboard/class', {
      params: { limit },
    });
    return response.data;
  },

  // Teacher: Get school leaderboard
  async getSchoolLeaderboard(limit = 10) {
    const response = await api.get('/leaderboard/school', {
      params: { limit },
    });
    return response.data;
  },

  // Get global leaderboard (public)
  async getGlobalLeaderboard(limit = 10) {
    const response = await api.get('/leaderboard/global', {
      params: { limit },
    });
    return response.data;
  },

  // Student: Get my class leaderboard (same grade level)
  async getMyClassLeaderboard(limit = 10) {
    const response = await api.get('/leaderboard/me/class', {
      params: { limit },
    });
    return response.data;
  },

  // Student: Get my school leaderboard
  async getMySchoolLeaderboard(limit = 10) {
    const response = await api.get('/leaderboard/me/school', {
      params: { limit },
    });
    return response.data;
  },

  // Student: Get my global leaderboard
  async getMyGlobalLeaderboard(limit = 10) {
    const response = await api.get('/leaderboard/me/global', {
      params: { limit },
    });
    return response.data;
  },

  // Student: Get my rank (class, school, global)
  async getMyRank() {
    const response = await api.get('/leaderboard/me/rank');
    return response.data;
  },
};

export default leaderboardService;
